import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: ${props => props.theme.maxWidth};
  margin: 30px auto 0;
  padding: 30px;
  ${bp('sm')`
    padding: 20px 0;
    flex-wrap: wrap;
  `}

  strong {
    font-weight: bold;
  }
`

export const Content = styled.div`
  flex-grow: 1;
  width: calc(100% - 260px);
  border-left: 1px solid ${props => props.theme.palette.general.greyLight};
  padding-left: 30px;
  ${bp('sm')`
    margin: 30px 0;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  `}

  .flex-title {
    justify-content: space-between;

    a {
      text-decoration: none;
      color: ${props => props.theme.palette.primary.alphaDark};
      font-weight: bold;

      :hover {
        color: ${props => props.theme.palette.primary.alpha};
      }
    }
  }
`

export const Title = styled.h1<any>`
  ${props => props.isSofiaAndGrace ? props.theme.css.heading1 : props.theme.css.heading2};
  margin: 0 0 30px;
  ${props => props.mainTitle && props.theme.css.containerWide};
  ${bp('sm')`
    padding: 0 20px;
  `}
`
